import React from "react";
import { Button, useTheme, useMediaQuery } from "@mui/material";

const PrimaryButton = ({ children, sx = {}, ...props }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Button
      variant="contained"
      color="primary"
      sx={{
        height: isMobile ? "32px" : "40px",
        minWidth: isMobile ? "60px" : "70px",
        fontSize: isMobile ? "12px" : "14px",
        padding: isMobile ? "20px 8px" : "6px 12px",
        borderRadius: "8px",
        fontWeight: "bold",
        textTransform: "none",
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default PrimaryButton;
